import { render, staticRenderFns } from "./BackTop.vue?vue&type=template&id=0b7c34fb&scoped=true&"
import script from "./BackTop.vue?vue&type=script&lang=js&"
export * from "./BackTop.vue?vue&type=script&lang=js&"
import style0 from "./BackTop.vue?vue&type=style&index=0&id=0b7c34fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c34fb",
  null
  
)

export default component.exports